import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { OdsServices } from '../../services';

/**
 * Generated class for the OdsConfigActiveElementsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ods-config-active-elements',
    templateUrl: 'ods-config-active-elements.html',
})
export class OdsConfigActiveElementsPage {
    active_section = '';
    active_section_index = 0;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public translate: TranslateService,
        public globals: Globals,
        public toastCtrl: ToastController,
        public odsServices: OdsServices,
        public loadingCtrl: LoadingController) {
        this.active_section = this.odsServices.carta_takeaway.pages[0].sections[0].name;
    }

    ionViewWillEnter() {
        this.globals.GAtrackView('Ods', 'Ods - De/Active - Elements', this.globals.restaurant.email, 'View', 'De/Active - Elements', 'Ods', '');
        // Iniciar listener para sincronización en tiempo real
        this.odsServices.startCartaTakeawayListener();
    }

    ionViewWillLeave() {
        // Detener listener al salir para evitar memory leaks
        this.odsServices.stopCartaTakeawayListener();
    }

    save() {
        // Con el guardado inmediato, los cambios ya están guardados
        // Este método solo cierra la pantalla
        this.navCtrl.pop();
    }

    styleButton(section) {
        return {
            'btn-active': section === this.active_section
        };
    }

    changeActiveSection(section, index) {
        this.active_section = section;
        this.active_section_index = index;
    }

    async markAsModified(element) {
        if (element && element.uid) {
            // Actualizar todas las instancias del mismo elemento en la carta
            this.updateAllElementInstances(element);
            
            // Guardar inmediatamente en Firestore para evitar pérdida de datos
            try {
                if (element.type === 'product') {
                    await this.odsServices.firestore.collection('products').doc(element.uid).update({
                        tk_active: (element.tk_active === undefined) ? true : element.tk_active
                    });
                } else if (element.type === 'dish') {
                    await this.odsServices.firestore.collection('dish').doc(element.uid).update({
                        tk_active: (element.tk_active === undefined) ? true : element.tk_active
                    });
                } else if (element.type === 'combo') {
                    await this.odsServices.firestore.collection('menus').doc(element.uid).update({
                        tk_active: (element.tk_active === undefined) ? true : element.tk_active
                    });
                }
                
                // IMPORTANTE: También actualizar la carta inmediatamente para que se refleje en pedidos online
                const cartaUpdate = { ...this.odsServices.carta_takeaway };
                delete cartaUpdate.UID;
                await this.odsServices.firestore.collection('cartas').doc(this.odsServices.carta_takeaway.UID).update(cartaUpdate);
                
                // Mostrar feedback visual de éxito
                const toast = this.toastCtrl.create({
                    message: this.translate.instant('instant-guardado-correctamente'),
                    duration: 2000,
                    position: 'bottom'
                });
                toast.present();
                
            } catch (error) {
                // Revertir el cambio en caso de error
                element.tk_active = !element.tk_active;
                this.updateAllElementInstances(element);
                
                // También revertir en la carta si es necesario
                try {
                    const cartaUpdate = { ...this.odsServices.carta_takeaway };
                    delete cartaUpdate.UID;
                    await this.odsServices.firestore.collection('cartas').doc(this.odsServices.carta_takeaway.UID).update(cartaUpdate);
                } catch (revertError) {
                    console.error('Error al revertir carta:', revertError);
                }
                
                // Mostrar mensaje de error
                const toast = this.toastCtrl.create({
                    message: this.translate.instant('general-error-al-guardar'),
                    duration: 3000,
                    position: 'bottom',
                    cssClass: 'toast-error'
                });
                toast.present();
                console.error('Error al actualizar tk_active:', error);
            }
        }
    }

    updateAllElementInstances(element) {
        // Recorrer todas las secciones
        this.globals.objectToArray(this.odsServices.carta_takeaway.pages[0].sections).forEach(section => {
            // Recorrer todos los elementos de cada sección
            this.globals.objectToArray(section.elements).forEach(elem => {
                // Si encontramos un elemento con el mismo uid, actualizamos su estado
                if (elem.uid === element.uid) {
                    elem.tk_active = element.tk_active;
                }
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/ods/ods-config/ods-config-active-elements/ods-config-active-elements.ts